import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HighIncomeDownPaymentHelp from "@/pages/tools/HighIncomeDownPaymentHelp";

export const Route = createFileRoute("/tools/high-income-down-payment-help")({
  head: () => seoHead("/tools/high-income-down-payment-help"),
  component: HighIncomeDownPaymentHelp,
});
